module.exports = __webpack_public_path__ + "static/media/handsGray.be22326d.svg";